import specs2 from "../../assets/img/specs2.png";

export default function SpecsSection() {
  return (
    <section className="specs section grid" id="specs">
      <h2 className="section__title section__title-gradient">Key Features</h2>

      <div className="specs__container container grid">
        <div>
          <img
            src={specs2}
            alt="App Features"
            className="specs__img specs__img--left"
          />
        </div>

        <div className="specs__content">
          <div className="specs__data">
            <i className="ri-database-2-line specs__icon" />
            <h3 className="specs__title">Extensive Aircraft Database</h3>
            <span className="specs__subtitle">
              Explore detailed profiles of thousands of military aircraft.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-focus-3-line specs__icon" />
            <h3 className="specs__title">3D Models & AR Views</h3>
            <span className="specs__subtitle">
              Get up close with interactive 3D models and augmented reality.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-global-line specs__icon" />
            <h3 className="specs__title">Global Inventories</h3>
            <span className="specs__subtitle">
              Discover aircraft inventories by country and manufacturer.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-star-line specs__icon" />
            <h3 className="specs__title">Favorites List</h3>
            <span className="specs__subtitle">
              Bookmark your favorite aircraft for quick and easy access.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-award-line specs__icon" />
            <h3 className="specs__title">Badges & Achievements</h3>
            <span className="specs__subtitle">
              Earn badges for rating aircraft, commenting, and more.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-discuss-line specs__icon" />
            <h3 className="specs__title">Community Engagement</h3>
            <span className="specs__subtitle">
              Rate and comment on aircraft to share your insights.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-newspaper-line specs__icon" />
            <h3 className="specs__title">Military Aviation Blog</h3>
            <span className="specs__subtitle">
              Stay informed with the latest news, trends, and developments.
            </span>
          </div>

          <div className="specs__data">
            <i className="ri-filter-3-line specs__icon" />
            <h3 className="specs__title">Powerful Search Tools</h3>
            <span className="specs__subtitle">
              Find exactly what you're looking for with advanced filters.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
